import { render, staticRenderFns } from "./ResellerEdit.vue?vue&type=template&id=677a9ef0"
import script from "./ResellerEdit.vue?vue&type=script&lang=js"
export * from "./ResellerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports